import React, { useState } from 'react';
import { Row, Col } from 'tea-component';
import BubbleCommon, {
  shortGoogleText,
} from '@/pages/opinion/components/BubbleCommon';
import CardCommon from '@/pages/opinion/components/CardCommon';
import LineContextCard from '@/pages/opinion/components/LineContextCard';

import { GameStoreMobileChart } from '../components/GameStoreMobileChart';
import { useIntl } from 'umi';
import HoverSvgIcon from '@/pages/opinion/components/HoverSvgIcon';
import useGetGameStoreStatsInfo from '../hooks/useGetGameStoreStatsInfo';
import useGetGameStoreTimelineInfo from '../hooks/useGetGameStoreTimelineInfo';
import { swapArray } from '@/pages/opinion/utils/value';

export default function GameStoreMobile({
  filter = {},
  gameInfo = {},
  handleTitleOnClick,
}: any) {
  const { formatMessage } = useIntl();
  const isWarFrame =
    gameInfo.edition_unified_id === 'u8f17b82647b7d5a6fd87af8a807d2b08';
  const [type, setType] = useState(isWarFrame ? 'app store' : 'google play');

  const filters = [
    {
      text: (
        <div className="dbo-inlineflex dbo-segment-tipsbox">
          <span>Google Play</span>
          <BubbleCommon
            placement="top"
            tipsMap={shortGoogleText}
            customIcon={
              <HoverSvgIcon selected={type === 'google play'}></HoverSvgIcon>
            }
          ></BubbleCommon>
        </div>
      ),
      value: 'google play',
    },
    { text: 'App Store', value: 'app store' },
    { text: 'Tap Tap', value: 'taptap' },
  ];
  if (isWarFrame) {
    swapArray(filters, 1, 0);
  }

  const { loading, ratingInfo, ratings } = useGetGameStoreStatsInfo({
    gameInfo,
    filter,
    type,
  });
  const { trendLoading, nodata, mobileTrendsInfo } =
    useGetGameStoreTimelineInfo({ gameInfo, filter, type });

  return (
    <Row className="dbo-cardrow-wrap">
      <Col>
        <CardCommon
          className="dbo-gamestorecard dbo-gamestorecard--mobile"
          hasTitleArrow
          title={formatMessage({ id: 'Game Store' })}
          filters={filters}
          handleFilterOnChange={(value) => {
            setType(value);
          }}
          handleTitleOnClick={() => handleTitleOnClick?.()}
        >
          <Row style={{ marginTop: 2 }}>
            <Col span={12}>
              <CardCommon contentCard loading={loading} loadingHeight={234}>
                <>
                  {ratings.map((e) => {
                    return (
                      <LineContextCard
                        key={e.id}
                        data={e}
                        filter={filter}
                        channel={type}
                        ratingInfo={ratingInfo}
                      />
                    );
                  })}
                </>
              </CardCommon>
            </Col>
            <Col span={12}>
              <CardCommon
                empty={nodata}
                loadingHeight={234}
                emptyHeight={234}
                loading={trendLoading}
                title={formatMessage({ id: 'Trends' })}
                contentCard
              >
                <GameStoreMobileChart
                  data={mobileTrendsInfo?.selected || {}}
                  filter={filter}
                  channel={type}
                  formatMessage={formatMessage}
                ></GameStoreMobileChart>
              </CardCommon>
            </Col>
          </Row>
        </CardCommon>
      </Col>
    </Row>
  );
}
